import React from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import CurrencySelector from '../dashboard/navigationPanel/CurrencySelector';
import ConvertedAmount from '../dashboard/navigationPanel/ConvertedAmount';

const VerifyTicketContent = ({ arr }) => (
  <div className={`preview-data-solde ${arr.length > 1 ? 'flex' : ''}`}>
    {arr && arr.length > 0 && arr[0].data && arr[0].data.map((item) => {
      const { data } = item;
      return (

        data?.length > 0 ? data.slice(5, -2).map((d) => d && (
        <span className="ticket-info" key={uuidv4()}>{d}</span>
        )) : null

      );
    })}
  </div>
);

const ResumeBetContent = ({ arr }) => (
  <div className="preview-data-solde">
    {
    arr.length > 1 ? arr.map((info, index) => info && (
      <div className="ticket-section" key={`Ticket-resume-${index + 1}`}>
        {
          (info?.length > 0 ? info.slice(5).map((item) => item && (
            <span className="ticket-info" key={uuidv4()}>{item}</span>
          )) : null)
        }
      </div>
    )) : null
    }
    {
    arr.length === 1 ? arr.map((info) => (
      info?.length > 0 ? info.slice(5).map((item) => item && (
        <span className="ticket-info" key={uuidv4()}>{item}</span>
      )) : null
    )) : null
    }
  </div>
);
const SoldeContent = ({ arr }) => (
  <div className="preview-data-solde">
    {(arr && arr.length > 0) ? arr.slice(1, -2).map((item) => item && (
      <span className="ticket-info" key={uuidv4()}>{item}</span>
    )) : null}
  </div>
);
const MessageContent = ({ text, color, fontSize }) => (
  <p style={{ color, fontSize: `${fontSize}px`, wordBreak: 'break-word' }}>{text}</p>
);

const WithdrawConfirmContent = ({
  text,
  color,
  amount,
  secondaryCurrencyConfigs,
  targetCurrencyConfig,
  onCurrencyChange,
  conversionRate,
  conversionLoading,
}) => (
  <div className="withdraw-confirm-content">
    <MessageContent text={text} color={color} />
    {secondaryCurrencyConfigs?.length > 0 && (
      <CurrencySelector
        secondaryCurrencyConfigs={secondaryCurrencyConfigs}
        targetCurrency={targetCurrencyConfig?.strCode || null}
        onChange={onCurrencyChange}
        variant="inline"
        id="withdraw-currency-selector"
      />
    )}
    {targetCurrencyConfig && (
      <ConvertedAmount
        amount={amount}
        rate={conversionRate}
        loading={conversionLoading}
        targetCurrencyConfig={targetCurrencyConfig}
      />
    )}
  </div>
);

MessageContent.propTypes = {
  text: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  fontSize: PropTypes.number,
};

MessageContent.defaultProps = {
  fontSize: 16,
};

VerifyTicketContent.propTypes = {
  arr: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
};

ResumeBetContent.propTypes = {
  arr: PropTypes.arrayOf(
    PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  ).isRequired,
};

SoldeContent.propTypes = {
  arr: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
};

WithdrawConfirmContent.propTypes = {
  text: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  secondaryCurrencyConfigs: PropTypes.arrayOf(PropTypes.shape({
    strCode: PropTypes.string,
  })),
  targetCurrencyConfig: PropTypes.shape({
    strCode: PropTypes.string,
  }),
  onCurrencyChange: PropTypes.func.isRequired,
  conversionRate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  conversionLoading: PropTypes.bool,
};

WithdrawConfirmContent.defaultProps = {
  secondaryCurrencyConfigs: [],
  targetCurrencyConfig: null,
  conversionRate: null,
  conversionLoading: false,
};

export {
  VerifyTicketContent, ResumeBetContent, MessageContent, SoldeContent, WithdrawConfirmContent,
};
